import { AxiosResponseType, ReportViewType } from '@/shared/types'
import { REPORT_VIEW } from '@/shared/constants'
import {
  commentApi,
  periodontalReportApi,
  screeningReportApi,
} from '@/shared/api'

export const removeComment = async (
  reportType: ReportViewType,
  commentId: number
): AxiosResponseType<any> => {
  switch (reportType) {
    case REPORT_VIEW.plaqueIndex:
      return await commentApi.removeComment(commentId)
    case REPORT_VIEW.periodontal:
      return await periodontalReportApi.removeComment(commentId)
    case REPORT_VIEW.screening:
      return await screeningReportApi.removeComment(commentId)
  }
}
